<template>
  <el-dialog
    title="切换企业"
    :visible.sync="showDialog"
    width="70rem"
    :close-on-click-modal="false"
    :append-to-body="true"
    :before-close="closeDialog"
  >
    <div class="setting-content"></div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CompanyChange',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    closeDialog() {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0;
  padding-top: 8px;
}

.setting-content {
  display: flex;
  border-top: 1px solid #eee;
  height: 450px;
}
</style>
